"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
const isObject = (value) => {
    return typeof value === 'object' && value !== null;
};
exports.isObject = isObject;
